<template>
    <div>
      <div style="height: 10px;"></div>
      <div class=" contentWidth">
        <p>我的收藏</p>
        <JobCard :types="3" v-for="item in list" :datas="item" @updateFavorite="updateFavorite" :type="'collect'"></JobCard>
        <!-- <JobCard></JobCard>
        <JobCard></JobCard> -->

        <pagination
            :total="pagination.totalRow"
            v-model="conditions.pageIndex"
            v-if="pagination.totalRow>0 && !loading"
            @change="pageChange">
        </pagination>
        <prompt v-if="list  &&  list.length < 1 && !loading"></prompt>
      </div>
      
    </div>
  </template>
  
  <script>
  import { mapActions, mapState } from "vuex";
  // import JobCard from './components/jobCard.vue';
  import JobCard from '../job/components/item.vue';
  export default {
    data() {
      return {
        conditions:{
          pageIndex:1,
          pageSize:10
        },
        loading:false,
        
      };
    },
    components:{JobCard},


    async created(){
      await this.getList()
    },
  
    computed: {
      ...mapState({
        list: state => state.user.favoritelist, //图形验证码
        pagination: state => state.user.favoPagination //个人信息
      }),
     
    },
    methods:{
      ...mapActions([
        "collectFavorite",
        "deleteFavorite",
      ]),
      async pageChange(e){
        this.conditions.pageIndex = e;
        await this.getList();
      },
      async getList() {
        this.loading = true;
        await this.collectFavorite({...this.conditions})
        this.loading = false;
      },
      async refreshData(){
        await this.getList();
      },
      //取消收藏
      async updateFavorite(id,collect){
        const res = await this.deleteFavorite(id);
        if (res) {
          this.conditions.pageIndex = 1;
          await this.getList();
          this.$message({
            message: "取消收藏!",
            type: "success"
          });
        }else {
          this.$message({
            message: res.message,
            type: "warning"
          });
        }
      },
    }
   
  };
  </script>
  
  <style lang="less" scoped>
  @mianColor:#287CF3;
  @whiteColor:#fff;
  @mainFontCol:rgba(0,0,0,0.85);
  @secondfontCol:rgba(0,0,0,0.5);
  @yellowColor:#FF8A16;
  .contentWidth{
    p{
      border-bottom: 1px solid #EBEBEB;
      padding-bottom: 8px;
    }
    .tabs-content{
        border-bottom: 1px solid #EBEBEB;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }
    /deep/.content{
      width: 1280px;
    }
    /deep/.content-left{
       width: 700px;
    }
    /deep/.content-otherinfo{
      width: 580px;
    }
  }
  .main{
    padding: 20px;
    background: @whiteColor;
    margin-top: 20px;
   
  }
  
  </style>
  